import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/auctions";
import type { ResponseConfig } from "@/api/client/auctions";
import type { DeleteAuctionDraftsMutationRequest, DeleteAuctionDraftsMutationResponse, DeleteAuctionDrafts400, DeleteAuctionDrafts401, DeleteAuctionDrafts403, DeleteAuctionDrafts500 } from "../types/DeleteAuctionDrafts";

/**
 * @description Метод предназначен для удаления предложений из черновиков (аукциона) https://confluence.poleinvest.ru/pages/viewpage.action?pageId=425486306
Удаления записи из базы не происходит. Аукционы меняют статус с DRAFT на DELETED.

 * @link /v1/auctions/do_delete-drafts
 */

export function useDeleteAuctionDrafts <TData = DeleteAuctionDraftsMutationResponse, TError = DeleteAuctionDrafts400 | DeleteAuctionDrafts401 | DeleteAuctionDrafts403 | DeleteAuctionDrafts500, TVariables = DeleteAuctionDraftsMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/v1/auctions/do_delete-drafts`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
